import React from 'react';
import { Link } from 'react-router-dom'

const HeroHeader = () => {
  return (
    <div className="container-fluid py-5 mb-5 hero-header">
      <video autoPlay loop muted className="hero-video">
        <source src="/assets/img/bg-hero.mp4" type="video/mp4" />
      </video>
      <div className="container py-5">
        <div className="row justify-content-center py-5">
          <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
            <h1 className="display-3 text-white mb-3 animated slideInDown">
              Boat Rentals & Repairs
            </h1>
            <p className="fs-4 text-white mb-4 animated slideInDown">
              Premium boat rental and repair services in Cape Coral
            </p>
            <div className="animated slideInDown">
              <Link to="/Rentals" className="btn btn-primary rounded-pill py-2 px-4">
                Reserve Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroHeader;
